import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);

    // Check the authentication status
    return inject(AuthService)
        .check()
        .pipe(
            switchMap((authenticated) => {
                // If the user is not authenticated...
                if (!authenticated) {
                    // A entrar, con la ruta pedida para volver ahí. Va como
                    // query param codificado: una ruta con su propio "?" o "&"
                    // ya no se parte.
                    const urlTree =
                        state.url === '/sign-out'
                            ? router.createUrlTree(['sign-in'])
                            : router.createUrlTree(['sign-in'], { queryParams: { redirectURL: state.url } });

                    return of(urlTree);
                }

                // Allow the access
                return of(true);
            })
        );
};
